import { Component } from 'react';
import { getBoards } from '../apihelper';
import BoardModule from './BoardModule';
import TabSwitcher from './TabSwitcher';
import {getBoardTypeIcon} from '../global/utils';
import dataManager from './data-manager';
import { BoardsObserver } from './Observer';

class Boards extends Component {
	constructor(props) {
		super(props);
		this.state  = {
			boards: [],
			controller: false,
			focusMode: false,
			focusBoardId: -1,
			tabList: [],
			switchViewAction: this.props.switchViewAction ? this.props.switchViewAction : false,
		};

		this.observer = false;
		this.moduleName = 'boards';
		this.createTabList = this.createTabList.bind(this);
		this.reactFn = this.reactFn.bind(this);

		dataManager.fetchData();
	}

	componentDidMount() {
		this.setupObserver();
		this.getBoardsData();
	}

	setupObserver() {
		const controller = dataManager.boardsController;

		this.observer = new BoardsObserver(this.reactFn);
		controller.addObserver(this.observer);

		this.setState({
			controller: controller
		});
	}

	getBoardsData() {
		const fetchInterval =
		setInterval(() => {
			const controller = this.state.controller;
			const boardObjects = controller.getBoardObjects();
			
			if ( boardObjects.length > 0 ) {
				this.dataReceived(boardObjects);
				clearInterval(fetchInterval);
			}

		}, 300);
		
	}

	reactFn() {
		const controller = this.state.controller;
		const newData = controller.getBoardObjects();

		this.setState({
			controller: controller
		})

		this.dataReceived(newData);
	};

	dataReceived(boards=[]) {
		this.setState({ boards: boards });
		this.createTabList(boards);
		
	}

	createTabList(boards=[]) {
		const tabList = [];

		boards.forEach((board, key) => {
			const tabItem = { 
					title: board.title,
					icon: getBoardTypeIcon(board.type),
					component: this.renderBoard(board, board.id)
			};
			tabList.push(tabItem);
		});

		this.setState({
			tabList: tabList
		})
	}


	renderBoard(boardData, key) {
		const focus = this.state.focusMode && this.state.focusBoardId === boardData.id;
		return (
			<BoardModule
					i={key}
					key={key}
					boardID={boardData.id}
					type={boardData.type}
					title={boardData.title}
					data={boardData}
					controller={boardData}
					focus={  focus  }
					switchViewAction={this.state.switchViewAction}
			/>
		)
	}

	focusBoard(boardId=23) {
		this.setState({
			focusMode: true,
			focusBoardId: boardId
		})
	}
	
	render() {
		const focusModeClass = this.state.focusMode ?  'focus-mode' : '';
		const tabList = this.state.tabList;

	    return (
			<TabSwitcher list={tabList} modifier={ this.moduleName } customClass={focusModeClass} />
	    );
  	}
}

export default Boards;